import { fetchApi } from "./fetchApi";

const url = "/api/serviceArea/filterPreset";

export const filterPresetApi = {
  async get(): Promise<any[]> {
    const response = await fetchApi({ method: "get", url });

    return response.data.result;
  },

  async put(presetList: any[]): Promise<void> {
    await fetchApi({
      data: presetList,
      method: "put",
      url,
    });
  },
};
